import { createAsyncThunk } from '@reduxjs/toolkit'
import { API_BASE_URL } from '../../constant'
import axios from 'axios'

axios.defaults.withCredentials = true;

/**
 * FETCH ALL CUSTOMERS   
 */
 
export const fetchAllCustomers = createAsyncThunk('customer/fetchAllCustomers', async ({ token }, { rejectWithValue }) => {
    try {
        const res = await axios.get(API_BASE_URL + `/allcustomers`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        })

        return res.data;

    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message)
    }
});